import React from "react";
import { BeakerIcon } from "./icons";

interface StartScreenProps {
  onStart: () => void;
}

const StartScreen: React.FC<StartScreenProps> = ({ onStart }) => {
  return (
    <div className="animate-fade-in flex flex-col items-center justify-center text-center p-8 bg-white rounded-2xl shadow-2xl max-w-2xl mx-auto border-4 border-teal-500 relative">
      <BeakerIcon />
      <h1 className="text-4xl font-bold text-gray-800 mt-4 mb-2">
        The Cosmetic Chemist Challenge!
      </h1>
      <p className="text-lg text-gray-600 mb-6">
        You're new to the cosmetic industry and trying to get a job. Your goal
        is to prove your knowledge by answering these 14 questions as quickly
        and accurately as you can. Be careful...the questions get trickier as
        you go along
      </p>
      <div className="flex flex-col items-center gap-4 w-full">
        <button
          onClick={onStart}
          className="bg-teal-500 text-white font-bold py-3 px-8 rounded-lg text-xl hover:bg-teal-600 transition-transform transform hover:scale-105 shadow-lg flex items-center justify-center w-80"
        >
          Begin Your Formulation
        </button>
      </div>
    </div>
  );
};

export default StartScreen;
